import React from 'react';

const Carousel = ({title, description, images}) => {
  return (
    <section className="carousel-section">
      <h2 className="carousel-title">{title}</h2>
      <p className="carousel-description">{description}</p>
      <div id={title.replace(/\s+/g, '')} className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-indicators">
         {images.map((_, index) => (
          <button
            key={index}
            type="button"
            data-bs-target={`#${title.replace(/\s+/g, '')}`}
            data-bs-slide-to={index}
            className={index === 0 ? 'active' : ''}
            aria-current={index === 0 ? 'true' : undefined}
            aria-label={`Slide ${index + 1}`}
          ></button>
         ))}
          <button
            type="button"
            data-bs-target={`#${title.replace(/\s+/g, '')}`}
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
        </div>
        <div className="carousel-inner">
          {images.map((mediaGroup, index) => (
            <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
              <div className="row">
                {mediaGroup.map((media, mediaIndex) => (
                  <div key={mediaIndex} className="col">
                    {media.type === 'image' ? (
                      <img
                        src={media.src}
                        className="d-block w-100 carousel-media"
                        alt={`Proyecto ${mediaIndex + 1}`} />
                    ) : (
                      <video
                        className="d-block w-100 carousel-media"
                        controls // Opcional: muestra los controles del video
                        muted // Opcional: inicia el video sin sonido
                        loop // Opcional: repite el video 
                        >
                        <source src={media.src} type="video/mp4" />
                        Tu navegador no soporta este video.
                      </video>
                    )}   
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target={`#${title.replace(/\s+/g, '')}`}
          data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#projectCarousel"
          data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </section>
  );
};

export default Carousel;
